module.exports = __webpack_public_path__ + "static/media/Aria-Shahrokhshahi-Documentary-Film-and-Photography.b1f35551.jpg";